var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconMoveUpTopLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconMoveUpTop",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M1920 1672.031v106.67H533.303v-106.67H1920ZM357.661 141l304.434 304.327L357.66 749.76l-75.308-75.521L457.93 498.66H106.562v1280.03H0V392.099h457.93l-175.577-175.79L357.66 141ZM1920 1245.249v106.775H533.303V1245.25H1920Zm0-426.57v106.67H533.303v-106.67H1920Zm-853.352-426.676v106.669H853.31v-106.67h213.338Zm426.676 0v106.669h-213.338v-106.67h213.338Zm426.676 0v106.669h-213.338v-106.67H1920Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconMoveUpTopLine.glyphName = 'move-up-top';
IconMoveUpTopLine.variant = 'Line';
IconMoveUpTopLine.displayName = 'IconMoveUpTopLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconMoveUpTopLine.propTypes = {
  ...SVGIcon.propTypes
};
IconMoveUpTopLine.allowedProps = [...SVGIcon.allowedProps];
export default IconMoveUpTopLine;
export { IconMoveUpTopLine };